module.exports = __webpack_public_path__ + "public/img/logo_ttd.7d35a4ff.png";